//Formik
import FormikTextInput from "../../../../helpers/formikInputs/FormikTextInput"

//Styles
import myStyles from "../../../../styles/kiosk/KioskAdminFormWizard.module.css"
import WizardPageActionsEmailRecipient from "./WizardPageActionsEmailRecipient"

import MessageBodyEditor from "./MessageBodyEditor"

export default function WizardPageActionsEmail({ staffList, disabled }) {
  const emailBodyFieldName = "submitActions[0].emailBody"
  const emailSubjectFieldName = "submitActions[0].emailSubject"

  return (
    <div className={myStyles.actionsContainer}>
      <div className={`${myStyles.actionTitle} ${myStyles.actionTitleMargin}`}>
        Send Email
      </div>
      <WizardPageActionsEmailRecipient
        staffList={staffList}
        fieldName={"submitActions[0].otherEmailRecipients"}
        disabled={disabled}
      />
      <FormikTextInput
        label={"Subject"}
        name={emailSubjectFieldName}
        disabled={disabled}
      />
      <MessageBodyEditor
        bodyFieldName={emailBodyFieldName}
        subjectFieldName={emailSubjectFieldName}
        height={280}
        disabled={disabled}
        label={"Message"}
      />
    </div>
  )
}
